import {BaseMockNextApis}             from "@Common/apis/next/base-mock-next-apis";
import {MockMailingApis}              from "@Common/apis/next/mailing/mock-mailing-apis";
import {mockNextInformedDeliveryApis} from "@Common/apis/next/mock-next-informed-delivery-apis";
import {mockNextNetworkingApis}       from "@Common/apis/next/mock-next-networking-apis";
import {MockNextSocialApis}           from "@Common/apis/next/mock-next-social-apis";
import {createArray}                  from "@Common/utils/collections";
import {chain}                        from "@Common/utils/fs";
import {arrMapToO, values}            from "@Common/utils/objects";
import {randomId, randomInt}          from "@Common/utils/random";
import {waitTimeout}                  from "@Common/utils/wait-timeout";

import {createNextApis}   from "../next-apis";
import {remapPricingData} from "../remap-pricing-data";

import {createMockState}  from "./create-mock-state";
import {mockNextCartApis} from "./mock-next-cart-apis";

// localStorage.cartStatus = "processing";
localStorage.cartStatus = "pending";
const itemState = createMockState(require("./sample-data/sample-item.js"));

// const itemState = createMockState(require("./sample-data/sample-item-legacy.js"));

export const createMockNextApis = ({}) => ({
    ...createNextApis({
        onUnauthorized: () => {
            window.location.href = "/next/index.php";
        },
    }),

    ...BaseMockNextApis(),

    getHolidays: () => [
        // "2022-01-19",
        "2022-01-20",
        "2022-01-21",
        "2021-12-23",
        "2021-12-24",
        "2022-01-05",
        "2021-12-31"
    ],

    getSystemConstants: async () => require("./sample-system-constants.js"),



    getCatSubStyle: async () => require("./CatSubStyle"),
    loadAccountMenu: async () => (
        //
        require("./sample-data/sample-account-menu-agent.js")
        // require("./sample-data/sample-account-menu-company.js")
    ),

    getStyleTemplate: async (subIds) => require("./StyleTemplate2"),
    getTemplateBack: () => require("./sample-template-back.js"),
    // getTemplateBack: () => {
    //     throw {
    //         status: 403,
    //         // message: "Mock error getTemplateBack",
    //     };
    // },

    getPricing: async () => chain(
        require("./pricing_2_1"),
        remapPricingData,
    ),

    searchTemplates: async () => require("./provided/search"),
    loadMenu: async () => require("./menu2.json"),
    getThemeScheme: async () => require("./scheme.js"),
    getOrdersInCart: async () => [],

    getNotifications: async () => ({
       messages: [
           // {
           //     'type': "information",
           //     'title': "info message",
           //     'message': "this is just an info message"
           // },
           // {
           //     'type': "warning",
           //     'title': "warning message",
           //     'message': "this is a warning message"
           // },
           // {
           //     'type': "error",
           //     'title': "error message",
           //     'message': "this is an ERROR level message"
           // },
       ],
    }),
    getActivePopupModals: async () => [
        {
            'id'                : 71,
            'title'             : "Mock Modal 1",
            'imageUrl'          : "https://images.theconversation.com/files/443350/original/file-20220131-15-1ndq1m6.jpg?w=926",
            'redirectUrl'       : "/next/app",
            'redirectNewWindow' : false,
        },
        {
            'id'                : 25,
            'title'             : "Mock Modal 2",
            'imageUrl'          : "https://media.npr.org/assets/img/2021/08/11/gettyimages-1279899488_wide-f3860ceb0ef19643c335cb34df3fa1de166e2761-s1100-c50.jpg",
            'redirectUrl'       : "/next/index.php",
            'redirectNewWindow' : true,
        },
    ],
    setPopupModalPref: async () => null,

    getBranchList: async () => require("./sample-branch-list.json"),
    getAgentList: async (idBranch) => require("./sample-agent-list")(idBranch),

    isLastProofAvailable: async () => {
        return [false];
    },


    gallery: {
        getAllowedPhotoGalleryTabs: async () => {
            return [
                "allow_property_photo_upload",
                "allow_property_photo_gallery",
                "allow_property_photo_services",
                "allow_property_photo_previous_order"
            ];
        },
        headshots: {
            getImages: () => require("./sample-headshots"),
            upload: async () => {
                const printUrl = "https://picsum.photos/seed/" + randomId() + "/200/300";
                return {
                    "dateCreated": "2024-01-23T19:35:06-06:00",
                    "dateModified": "2024-01-23T19:35:06-06:00",
                    "name": "BBB",
                    "fileType": "jpg",
                    "fileSize": 546641,
                    "thumbnailUrl": printUrl,
                    "quality": "High",
                    "defaultSlot": 0,
                    "width": 1365,
                    "height": 2048,
                    // "printUrl": "https:\/\/assets.awsdev.xpressdocs.com\/pictures\/headshot\/2024\/01\/23\/4\/32408853o.jpg",

                    printUrl: printUrl,
                    "id": randomInt(),
                };
            },
            delete: (headshotId, {agentId}) => {},
        },

        logos: {
            getImages: () => {
                return [
                    {
                        "dateCreated": "2025-04-23T05:02:02-05:00",
                        "dateModified": "2025-04-23T05:02:02-05:00",
                        "name": "AAA",
                        "fileType": "jpg",
                        "fileSize": 273361,
                        "designCode": null,
                        "width": 1024,
                        "height": 1024,
                        "thumbnailUrl": "https://picsum.photos/seed/k2ws1/200/300",
                        "printUrl": "https://picsum.photos/seed/k2ws1/200/300",
                        "id": 35258327
                    },
                    {
                        "dateCreated": "2025-04-23T04:41:53-05:00",
                        "dateModified": "2025-04-23T04:41:53-05:00",
                        "name": "test",
                        "fileType": "jpg",
                        "fileSize": 86108,
                        "designCode": null,
                        "width": 214,
                        "height": 300,
                        "thumbnailUrl": "https://picsum.photos/seed/gf4534/200/300",
                        "printUrl": "https://picsum.photos/seed/gf4534/200/300",
                        "id": 35258311
                    }
                ];
            },
        },
    },
    getTemplateOptions: async (a) => {
        // await waitTimeout(1000);
        // console.log("getTemplateOptions", a);
        return chain(
            (() => {
                return require("./sample-data/sample-template-options.js");
                // if (a.front == "334166") {
                //     return require("./sample-data/sample-template-options-0.js");
                // } else {
                //     return require("./sample-data/sample-template-options.js");
                // }
            })(),
            (_) => ({..._, sku: a}),
        );
        // return require("./sample-data/sample-template-options-legacy.js");
        // return require("./sample-data/sample-template-options-2");
    },
    // getTemplateOptions: async () => require("./sample-data/sample-template-options-pickPack-2"),
    // getTemplateOptions: async () => null,
    getCountryCodes: async () => ({US: "USA", "CA": "Canada"}),

    getCustomerAgreement: async () => [
        {
            description: "DEV customer agreement",
        }
    ],

    getThumbnailData: async () => {
        return ["https:\/\/assets.awsdev.xpressdocs.com\/dserv\/tpl\/large\/1\/393819.jpg"];
    },
    lastProofError: async () => {
        return [];
    },

    agent: {
        getAllUsers: () => require("./sample-data/sample-all-users.js"),
    },
    session: {
        // getEmulation: async () => ({type: "none"}),
        // getEmulation: async () => ({
        //     type: "branch",
        //     value: {
        //         branchId: "32517238",
        //     },
        //     branch: {
        //         "branchName":"Demo Office"
        //     },
        // }),

        // No longer used
        // getEmulation: async () => ({
        //     type: "agent",
        //     value: {
        //         agentId: "a637456c60",
        //         branchId: "32517238",
        //     },
        //     agent: {
        //         "agentNameFirst":"Gail",
        //         "agentNameLast":"Test"
        //     },
        //     branch: {
        //         "branchName":"Demo Office"
        //     },
        // }),
        validateActiveEntity: async () => ({
            "code":"match",
            "msg":"The active entity matches your input",
        }),

        ...(() => {
            const userPath = [
                {"idBranch": "933SPOKANE", "branchName": "Spokane-Valley"},
                {
                    "idAgent": "0d724c3ab9",
                    "idBranch": "933SPOKANE",
                    "agentNameFirst": "Jane",
                    "agentNameLast": "Doe"
                }
            ];
            return {
                getUserPath: async () => {
                    // await waitTimeout(1000);
                    return userPath;
                },
                emulateBranch: async ({branchId}) => {
                    // await waitTimeout(500);
                    console.log("emulateBranch", {branchId})
                    return userPath;
                },

                emulateAgent: async ({branchId, agentId}) => {
                    // await waitTimeout(500);
                    console.log("emulateAgent",{branchId, agentId});
                    return userPath;
                },
                emulateBranchOrder: async ({branchId}) => {
                    console.log("emulateBranchOrder", {branchId});
                    return userPath;
                },
                clearEmulation: async () => {
                    console.log("clearEmulation");
                    return userPath;
                },
            };
        })(),

        setSessionListing: async () => {},

        clearSessionOrder: async () => {
            console.log("clearSessionOrder");
        },
        getUserLevels: async () => {
            // console.log("getUserLevels");
            // return 2;
            return {idUser: 3235,userLevel: 3, internalUser: true}; // Company
            // return {userLevel: 4}; // Branch
            // return {
            //     userLevel: 5,
            //     internalUser: true,
            // }; // Agent
            // return 2;

            return require("./mock-user-levels").userLevels;
        },

        // getExistingOrderSessionInfo: async () => null,
        getExistingOrderSessionInfo: async () => ({
            "autoClearSession":false,
            "promptUser":true,
            "orderID":8888990,
            "orderName":"123 Main St",
            "templateName":"5 Photo Large",
            "productName":"5.5 x 8.5 Large Postcard"
        }),


        getAgent: async ({agentId=null}={}) => {
            return require("./sample-data/agent.js");
            // await waitTimeout(200);
            // if (agentId == null) {
            //     return require("./sample-data/agent.js");
            // } else {
            //     return {
            //         "idPrimary":2214299,"dateCreation":"2022-10-04 08:15:13","dateModification":"2022-10-04 11:20:32","idCompany":"9014f014","idBranch":"9d099077","idAgent":"f609dedb12","idUser":1874703,"idPublic":"","agentDisplay1":"43314d6cb5 ","agentDisplay2":"","agentDisplay3":"","agentDisplay4":"","agentDisplay5":"000000000","agentDisplay6":"","agentDisplay7":"testAbc@gmail.com","agentDisplay8":"","agentEmail":"testAbc@gmail.com","agentFax":"","agentIdentifier":"0af342ec2d072e1385914a2ddbf80fdc","agentInvoiceBranch":0,"agentInvoiceBranchLimit":0,"agentNameFirst":"43314d6cb5","agentNameLast":"","agentNameMiddle":"","agentPhone1":"","agentPhone2":"","agentRandom":"6604","agentActive":1,"agentRegistered":0,"agentWebsite":"","agentDeleted":0,"agentLinkId":"43314d6cb5Abc","agentPhoto1":"","agentPhoto2":"","emailOptOut":0,"agentHearAbout":0,"referrer":"","popNotification":"","agentDisplayName":"","agentPhone3":"","licenseNumber":"","flowthruOrigin":"saml","avalaraUsageType":"","nonProfitStatus":0,"defaultHeadshot":0,"defaultHeadshot2":0,"meta1":"","meta2":"","sourceIdAgent":"","allowFeedUpdate":1,"source":"saml","agentAddress1":"","agentAddress2":"","agentCity":"","agentState":"","agentCountry":"","agentZip":"","agentTitle":"","costCenterNum":"","allowAdminsToShare":1,"newYorkSalesTax":0,"imageGallery":{"headshots":[],"logos":[]},"defaultHeadshotId":0,"defaultHeadshot2Id":0,"subscriptions":[],"activeAddressableOrMailableTemplate":true};
            // }
        },
        getRegion: async () => require("./sample-data/region.json"),
        getBranch: async () => {
            // await waitTimeout(500);
            // console.log("getBranch");
            return require("./sample-branch");
        },
        getCompany: async () => require("./sample-data/sample-company.js"),
        getMessages: async () => [],
        getSuggestedComments: async ({request}) => {
            return {
                "Any": {
                    "1551369140": {
                        "idCommentSet": "6d0a1d70",
                        "idComment": "1551369140",
                        "type": "Any",
                        "headline": "Prospecting and Personal Promotion Message 4:",
                        "comments": "At (MUST TYPE YOUR BRANCH NAME HERE) Sotheby's International Realty, we have found that adequately representing unique properties requires unique skills. Over the years, our agents have developed innovative marketing tools and relationships with some of the most qualified buyers in the world. They have also developed a love for getting to know a house down to its most intimate detail. In the end, we don't so much sell a home as part with it. To market a distinctive home requires uncommon knowledge and resources, allow me to represent you.",
                        "idCommentCategory": 2,
                        "name": "Comments"
                    },
                }
            };
        },
    },

    mailing: MockMailingApis({}),

    shipping: {
        getShippingRates: async () => {
            // await waitTimeout(500);
            return require("./sample-data/sample-shipping-rates.js");
        },
        getConsolidatedShippingRates: async ({addressId, cartId, isInternalUser}) => {
            // await waitTimeout(300);
            return require("./sample-data/sample-shipping-rates.js");
        },
        getMyShippingAddresses: async () => chain(
            require("./sample-data/sample-shipping-address.js"),
            (_) => createArray(5).map((i) => ({
                ..._,
                idPrimary: i+100,
                contactName: _.contactName + "-" + i,
            }))
        ),
        getOfficeShippingAddress: async () => require("./sample-data/sample-shipping-address.js"),

        // getMyShippingAddresses: async () => [],
        // getOfficeShippingAddress: async () => null,

        addShippingAddress: async () => ({idPrimary: randomId()}),
        updateShippingAddress: async () => {},
        deleteShippingAddress: async () => {},


        validateAddress: async (address) => [{
            DeliveryPointValidation: "CONFIRMED",
            // DeliveryPointValidation: "UNCONFIRMED",
            // DeliveryPointValidation: address.startsWith("aaa") ? "CONFIRMED" : "UNCONFIRMED",
        }],
    },
    item: {
        createItem: async (item) => {
            console.log("createItem", item);

            return itemState.get();
        },
        updateItem: async (item) => {
            console.log("update item", item);
            await waitTimeout(500);

            // return {errors: {msg: "Mock error"}};
            return item;
        },
        getItem: async (itemId) => itemState.get(),
        // deleteItem: async (itemId) => postJsonAuth(`/next-api/item/delete_item`, {itemId}),

        getHistory: async () => require("./sample-data/sample-item-history.js"),

        getItemProofs: async () => {
            // await waitTimeout(100);
            // return {
            //     errors: {
            //         code: "timeout",
            //         // code: "failed",
            //         msg: "Test error message",
            //     },
            // };
            // await waitTimeout(200);
            return ({
                // oiaProofs: null,
                // oiaProofs: [
                //     "https://picsum.photos/seed/rj439/200/300",
                //     "https://picsum.photos/seed/jfru2/200/300",
                // ],
            });
        },

        cloneItem: async ({cloneItemJson}) => {
            return {
                // itemId: 111,
                errors: {
                    msg: "Testing cloneItem error",
                },
            };
        },
        getPending: async () => require("./sample-data/sample-item-pending-requests"),
    },

    order: {
        getDefaultFieldValues: async () => require("./sample-data/sample-order-default-values"),
        getContentFields: async () => require("./sample-data/sample-order-content-fields"),
        saveImageAssetReferences: async () => [],
        getColorSet: async () => {
            return require("./sample-order-colorSet.js");
        },
        getSpecFields: async () => {
            return require("./sample-order-SpectFields.js");
        },
    },
    OrderManager: {
        getOrderData: (idOrder, idComponent=null) => {
            return require("./sample-OrderManager-order-data.js");
        },
        updateBranchAgentOrderData: (idOrder, idCompany, idBranch, idAgent, idComponent=null) => {
            return require("./sample-OrderManager-BranchAgentOrderData.js");
        },
        getOrderImageFields: (idOrder, idComponent=null) => {
            return require("./sample-OrderManager-OrderImageFields.js");
        },
        getColorFields: async () => {
            return {"colorField1":null,"colorField2":null};
        },
        getOrderColumn: async () => {
            return "1 Photo X-Large";
        },
    },

    cart: mockNextCartApis,
    creditCard: {
        getCreditCards: async () => chain(
            require("./sample-data/sample-credit-cards").creditCards,
            (_) => !_ ? [] : Array.isArray(_) ? _ : [_],
        ),
        getAuthorizationToken: async () => "DEV_auth_token",
        addUpdate: async () => {},
        makeCardDefault: async () => {
            await waitTimeout(1000);
        },
        deleteCard: async (cardToken) => {},
    },
    vouchers: {
        // GET /next-api/voucher/get_voucher_history/
        getVoucherHistory: async () => {
            // await waitTimeout(500);
            return require("./sample-data/sample-voucher-history");
        },

        getVouchers1: async (filter) => {
            // console.log("getVouchers1 filter:", filter);
            // await waitTimeout(500);
            return ([
                {
                    "idVoucher": "f737f3940a",
                    "idAgent": "eba3652def",
                    "name": "Main",
                    "agentFullName": "Gail Test",
                    "idBranch": "5464674a",
                    "branchName": "Woburn",
                    "dateExpiration": "-0001-11-30T00:00:00-06:00",
                    "dateModified": "2022-05-13T21:52:26-05:00",
                    "total": "8.00",
                },
                {
                    "idVoucher": "f341e3a95d",
                    "idAgent": "111",
                    "name": "Test JLJS",
                    "idBranch": "5464674a",
                    "branchName": "Woburn",
                    "agentFullName": "Jonathan Agentname",
                    "dateExpiration": "-0001-11-30T00:00:00-06:00",
                    "dateModified": "2022-04-22T21:44:45-05:00",
                    "total": "10.00",
                },
            ]);
        },
        getVoucherHistory1: async () => chain(
            {
                "f737f3940a":{
                    "idVoucher":"f737f3940a",
                    "name":"Main",
                    "fullName":"Gail Test",
                    "idUser":"a637456c60",
                    "agentEmail":"capture-service@asteroom.com",
                    "total":"8.00",
                    "branchName":"Demo Office",
                    "history":[
                        {
                            "idPrimary":195303,
                            "dateCreated":"2022-05-13T21:52:26-05:00",
                            "dateModified":"2022-05-13T21:52:26-05:00",
                            "idVoucher":"f737f3940a","amount":8,"comments":"",
                            "systemComments":"Created voucher with 8 starting balance.",
                            "xdocsUsage":false,
                        }
                    ],
                },
            },
            (_) => values(_)[0],
        ),
    },

    approval: {
        // getApprovalRequests: async () => require("./sample-data/sample-approval-requests"),
        getApprovalRequests: async () => require("./sample-data/sample-approval-requests-2"),
        denyCcCart: async () => {
            // await waitTimeout(100);
            return {result: "success"};
        },
        denyLegacyOrder: async () => {
            // await waitTimeout(100);
            return {result: "success"};
        },
        approveCcCart: async () => {
            // await waitTimeout(100);
            // return {result: "success"};
            // return {result: "error", message: "dwi weif uwei uwefni wenfwei nweif nwief nweiufn"};
            return {result: "failure", errors: {msg: "rferf4 43"}};
        },
        approveLegacyOrder: async () => {
            // await waitTimeout(100);
            return {result: "success"};
        },
        getPendingRequests: async () => require("./sample-data/sample-approval-pending-requests"),

        getOciForm: async () => ({
            result: "0",
            ociForm: `
                <form id="srm_form" action="https://tecraaalam-web.awsdev.xpressdocs.com/next/xadmin/test_tools/punchout_order_post_process.php?sso_type=oci&order_ids=13287894" target="_top" method="POST">
                    <input name="NEW_ITEM-LINE[1]" type="hidden" value="00001"/>
                    <input name="NEW_ITEM-VENDORMAT[1]" type="hidden" value="13287894"/>
                    <input name="NEW_ITEM-DESCRIPTION[1]" type="hidden" value="20 page (16+4), SS on Side  (Flat Rate $155.00)"/>
                    <input name="NEW_ITEM-MANUFACTMAT[1]" type="hidden" value="478898"/>
                    <input name="NEW_ITEM-LONGTEXT_1:132[]" type="hidden" value="25"/>
                    <input name="NEW_ITEM-QUANTITY[1]" type="hidden" value="1"/>
                    <input name="NEW_ITEM-CURRENCY[1]" type="hidden" value="USD"/>
                    <input name="NEW_ITEM-PRICEUNIT[1]" type="hidden" value="1"/>
                    <input name="NEW_ITEM-LEADTIME[1]" type="hidden" value="3"/>
                    <input name="NEW_ITEM-UNIT[1]" type="hidden" value=""/>
                    <input name="NEW_ITEM-VENDOR[1]" type="hidden" value=""/>
                    <input name="NEW_ITEM-MATGROUP[1]" type="hidden" value=""/>
                    <input name="NEW_ITEM-CONTRACT[1]" type="hidden" value=""/>
                    <input name="NEW_ITEM-CONTRACT_ITEM[1]" type="hidden" value=""/>
                    <input name="NEW_ITEM-PRICE[1]" type="hidden" value="155.00"/>
                    <input style="display: none;" id="srm_form_submit" type="submit" value="Go"/>
                </form>
            `,
        }),

        processProcurement: async () => ({
            "transmissionType": "http",
            "result": "0",
            "procurement": (
                "<!DOCTYPE html>\n" +
                "<HTML>\n" +
                "<HEAD>\n" +
                "<title>PunchBack</title>\n" +
                "</HEAD>\n" +
                "<body >\n" +
                "<div style=\"display: none;\">\n" +
                "<form id=\"srm_form\" action=\"https://www.buyerquest.net/spendsmart/punchoutclient/transactions/cxmlresponse/conn_id/12/\" method=\"post\" target=\"_top\">\n" +
                "<input id=\"cXML-urlencoded\" name=\"cXML-urlencoded\" type=\"hidden\" value=\"&lt;?xml version=&quot;1.0&quot; encoding=&quot;UTF-8&quot;?&gt;\n    &lt;!DOCTYPE cXML SYSTEM &quot;http://xml.cxml.org/schemas/cXML/1.1.007/cXML.dtd&quot;&gt;\n    &lt;cXML version=&quot;1.1.007&quot; xml:lang=&quot;en-US&quot; payloadID=&quot;2022-11-04 13:55:42@xpressdocs.com&quot; timestamp=&quot;2022-11-04 13:55:42&quot;&gt;\n        &lt;Header&gt;\n            &lt;From&gt;\n                &lt;Credential domain=&quot;NetworkId&quot;&gt;\n                    &lt;Identity&gt;MCDONALDS&lt;/Identity&gt;\n                &lt;/Credential&gt;\n            &lt;/From&gt;\n            &lt;To&gt;\n                &lt;Credential domain=&quot;NetworkId&quot;&gt;\n                    &lt;Identity&gt;43c1ea8f&lt;/Identity&gt;\n                &lt;/Credential&gt;\n            &lt;/To&gt;\n            &lt;Sender&gt;\n                &lt;Credential domain=&quot;NetworkId&quot;&gt;\n                    &lt;Identity&gt;MCDONALDS&lt;/Identity&gt;\n                    &lt;SharedSecret&gt;d9043bc2d9d5b7f097527613b6d2dacf&lt;/SharedSecret&gt;\n                &lt;/Credential&gt;\n                &lt;UserAgent&gt;Buyerquest Punchout WebClient&lt;/UserAgent&gt;\n            &lt;/Sender&gt;\n        &lt;/Header&gt;\n        &lt;Message&gt;\n        &lt;PunchOutOrderMessage&gt;\n            &lt;BuyerCookie&gt;5e0858f127d7bea876bfc0491d6ea6e5&lt;/BuyerCookie&gt;\n            &lt;PunchOutOrderMessageHeader operationAllowed='edit'&gt;\n                &lt;Total&gt;\n                    &lt;Money currency=&quot;USD&quot;&gt;177.1&lt;/Money&gt;\n                &lt;/Total&gt;\n            &lt;/PunchOutOrderMessageHeader&gt;\n\n            &lt;ItemIn quantity='500'&gt;\n                &lt;ItemID&gt;\n                    &lt;SupplierPartID&gt;392648-13337453&lt;/SupplierPartID&gt;\n                    &lt;SupplierPartAuxiliaryID&gt;13337453&lt;/SupplierPartAuxiliaryID&gt;\n                &lt;/ItemID&gt;\n                &lt;ItemDetail&gt;\n                    &lt;UnitPrice&gt;\n                        &lt;Money currency='USD'&gt;177.1&lt;/Money&gt;\n                    &lt;/UnitPrice&gt;\n                    &lt;Description xml:lang='en'&gt;&lt;![CDATA[ Gold Foil Standard Executive Envelope - Personal Imprint ]]&gt;&lt;/Description&gt;\n                    &lt;UnitOfMeasure&gt;EA&lt;/UnitOfMeasure&gt;\n                    &lt;Classification domain='UNSPSC'&gt;&lt;/Classification&gt;\n                    &lt;Extrinsic name='MinQuantity'&gt;0&lt;/Extrinsic&gt;\n                    &lt;Extrinsic name='OrderMultiple'&gt;0&lt;/Extrinsic&gt;\n                &lt;/ItemDetail&gt;\n            &lt;/ItemIn&gt;\n        &lt;/PunchOutOrderMessage&gt;\n    &lt;/Message&gt;\n    &lt;/cXML&gt;\" />\n" +
                "<input id=\"srm_form_submit\" style=\"display: none;\" type=\"submit\" value=\"Go\" />\n" +
                "</form>\n" +
                "</div>\n" +
                "</body>\n" +
                "</HTML>"
            )
        }),
    },

    location: {

        // URL : /next-api/location/get_eddm_cities/
        // Request: {"states":[{"code":"HI"},{"code":"CT"},{"code":"MH"}]}
        // Response: {"HI":["AHUALOA","AIEA","ANAHOLA","BANCORP","BANCORP HAWAII","BANK OF HAWAII","BOARD OF WATER SUPPLY","CAMP H M SMITH","CAMP SMITH","CAPTAIN COOK","EAST WEST CENTER","ELEELE","EWA BEACH","FIRST HAWAIIAN BANK","FORT SHAFTER","HAIKU","HAKALAU","HALEIWA","HANA","HANA MAUI","HANALEI","HANAMAULU","HANAPEPE","HAUULA","HAWAII NATIONAL PARK","HAWAII NATL PARK","HAWAIIAN ELECTRIC COMPANY","HAWAIIAN TELCOM","HAWI","HELEMANO MLTRY RES","HELEMANO MLTRY RESERVATION","HI NATL PARK","HICKAM AFB","HILO","HOLUALOA","HON","HONAUNAU","HONO","HONOKAA","HONOLULU","HONOMU","HOOLEHUA","JB PEARL HARBOR HICKAM","JBPHH","JOINT BASE PEARL HBR HICKAM","KAAAWA","KAHUKU","KAHULUI","KAILUA","KAILUA KONA","KALAELOA","KALAHEO","KALAUPAPA","KAMUELA","KANEOHE","KAPAA","KAPAAU","KAPOLEI","KAUMAKANI","KAUNAKAKAI","KAWAIHAE","KEAAU","KEALAKEKUA","KEALIA","KEAUHOU","KEKAHA","KIHEI","KILAUEA","KOLOA","KUALAPUU","KULA","KUNIA","KURTISTOWN","LAHAINA","LAIE","LANAI CITY","LAUPAHOEHOE","LAWAI","LIHUE","MAKAKILO","MAKAWAO","MAKAWELI","MAUNALOA","MCBH K BAY","MCBH KANEOHE BAY","MILILANI","MOUNTAIN VIEW","NAALEHU","NANAKULI","NINOLE","OCEAN VIEW","OOKALA","PAAUHAU","PAAUILO","PAHALA","PAHOA","PAIA","PAPAALOA","PAPAIKOU","PEARL CITY","PEARL HARBOR","PEARL HARBOR NAVAL BASE","PEPEEKEO","PRINCEVILLE","PUKALANI","PUKALANI MAUI","PUUNENE","SCHOFIELD","SCHOFIELD BARRACKS","TRIPLER AMC","TRIPLER ARMY MED CTR","TRIPLER ARMY MEDICAL CENTER","UNIVERSITY OF HAWAII","VOLCANO","WAHIAWA","WAIALUA","WAIANAE","WAIKOLOA","WAILEA","WAILUKU","WAIMANALO","WAIMEA","WAIPAHU","WAKE ISLAND","WHEELER AAF","WHEELER ARMY AIRFIELD"],"CT":["A A R P PHARMACY","ABINGTON","ADVERTISING DISTR CO","AETNA INSURANCE","AETNA LIFE","ALLSTATE","AMSTON","ANDOVER","ANSONIA","ASHFORD","AVON","BAKERSVILLE","BALLOUVILLE","BALTIC","BANK OF AMERICA","BANTAM","BARKHAMSTED","BARRY SQUARE","BEACON FALLS","BELLE HAVEN","BERLIN","BETHANY","BETHEL","BETHLEHEM","BISHOPS COR","BISHOPS CORNER","BISSELL","BKLN","BLOOMFIELD","BLOOMINGDALES BY MAIL LTD","BLUE HILLS","BOLTON","BOROUGH","BOTSFORD","BOZRAH","BRADLEY INTERNATIONAL AIRPOR","BRANFORD","BRIDGEPORT","BRIDGEWATER","BRISTOL","BROAD BROOK","BROOKFIELD","BROOKFIELD CENTER","BROOKFLD CTR","BROOKLYN","BURLINGTON","C T MUTUAL INSURANCE CO","CANAAN","CANTERBURY","CANTON","CANTON CENTER","CENTER GROTON","CENTERBROOK","CENTERVILLE MOUNT CARMEL","CENTRAL","CENTRAL VILLAGE","CENTRAL VLG","CHAPLIN","CHERRY BROOK","CHESHIRE","CHESTER","CHESTERFIELD","CHESTNUT HILL","CLINTON","COBALT","COLBROOK","COLCHESTER","COLEBROOK","COLLINSVILLE","COLUMBIA","CONANTVILLE","CONN BANK & TRUST CO","CONNECTICUT STATE PRISON","CONTROLLED DISTRIBUTION","CORBINS CORNER","CORNWALL","CORNWALL BRG","CORNWALL BRIDGE","COS COB","COVENTRY","CROMWELL","CT DEPT OF MOTOR VEHICLES","CT GEN MED CLAIMS OFFICE","DANBURY","DANIELSON","DARIEN","DAYVILLE","DEEP RIVER","DERBY","DURHAM","E GLASTONBURY","E GLSTNBRY","E HARTFORD","E HAVEN","E HTFD","E KILLINGLY","E WINDSOR HL","E WOODSTOCK","EAST BERLIN","EAST BROOKLYN","EAST CANAAN","EAST END","EAST GLASTONBURY","EAST GRANBY","EAST HADDAM","EAST HAMPTON","EAST HARTFORD","EAST HARTLAND","EAST HAVEN","EAST HTFD","EAST KILLINGLY","EAST LYME","EAST NORWALK","EAST PUTNAM","EAST THOMPSON","EAST WILLINGTON","EAST WINDSOR","EAST WINDSOR HILL","EAST WOODSTOCK","EASTFORD","EASTON","ELLINGTON","ELLIOT","ELMWOOD","ENFIELD","ESSEX","EXETER","FABYAN","FAIR HAVEN","FAIRFIELD","FALLS VILLAGE","FARMINGTON","FENWICK","FITCHVILLE","FORBES VILLAGE","FORESTVILLE","FOSDICK CORP","FRANKLIN","FRANKLIN HILL","FT TRUMBULL","GALES FERRY","GAYLORDSVILLE","GECC","GENERAL ELECTRIC","GEORGETOWN","GILMAN","GLASGO","GLASTONBURY","GLENBROOK","GLENVILLE","GOSHEN","GRANBY","GREENS FARMS","GREENWICH","GRISWOLD","GROSVENOR DALE","GROSVENOR DL","GROTON","GROTON LONG POINT","GUILFORD","GURLEYVILLE","HADDAM","HADDAM NECK","HADLYME","HAMDEN","HAMPTON","HANOVER","HARTFORD","HARTFORD INSURANCE GROUP","HARTFORD NATL BANK","HARTFRD","HARWINTON","HAWLEYVILLE","HAZARDVILLE","HEBRON","HFD","HIGGANUM","HOPEVILLE","HOTCHKISS SCHOOL","HTD","HTFD","HUNTINGTON","INTERNATIONAL MASTERS PUB","IRS","IVORYTON","JC PENNEY CO","JEWETT CITY","JORDAN VILLAGE","JUPITER POINT","KENINGTON","KENSINGTON","KENT","KILLINGLY","KILLINGLY CENTER","KILLINGWORTH","LAKE GARDA","LAKESIDE","LAKEVILLE","LAUREL HILL","LEBANON","LEDYARD","LISBON","LITCHFIELD","LORDS POINT","LYME","MACYS BY MAIL","MADISON","MAIN OFFICE","MANCHESTER","MANSFIELD","MANSFIELD CENTER","MANSFIELD CTR","MANSFIELD DEPOT","MANSFIELD DPT","MANSFIELD HOLLOW","MARBLE DALE","MARION","MARLBORO","MARLBOROUGH","MASHANTUCKET","MASONS ISLAND","MBI INC","MCDOUGAL CORRECTIONAL FCLTY","MECHANICSVILLE","MELROSE","MERIDEN","MERROW","MIDDLE HADDAM","MIDDLEBURY","MIDDLEFIELD","MIDDLETOWN","MILFORD","MILLDALE","MILLSTONE","MONROE","MONTVILLE","MOODUS","MOOSUP","MORRIS","MOUNT CARMEL","MYSTIC","N BRANFORD","N FRANKLIN","N GROSVENORDL","N HAVEN","N STONINGTON","N WESTCHESTER","NAUGATUCK","NAVAL SUBMARINE BASE","NAVSUB BASE","NEPAUG","NEW BRIT","NEW BRITAIN","NEW CANAAN","NEW FAIRFIELD","NEW HARTFORD","NEW HAVEN","NEW LONDON","NEW MILFORD","NEW PRESTON","NEW PRESTON MARBLE DALE","NEW PRESTON MARBLEDALE","NEW PRESTON-MARBLE DALE","NEWINGTON","NEWTOWN","NIANTIC","NO CANAAN","NO HAVEN","NOANK","NORFOLK","NOROTON","NOROTON HEIGHTS","NORTH BRANFORD","NORTH CANAAN","NORTH CANTON","NORTH FRANKLIN","NORTH GRANBY","NORTH GROSVENDALE","NORTH GROSVENORDALE","NORTH HAVEN","NORTH LYME","NORTH STERLING","NORTH STONINGTON","NORTH THOMPSONVILLE","NORTH WESTCHESTER","NORTH WINDHAM","NORTHEAST AREA","NORTHFIELD","NORTHFORD","NORTHVILLE","NORWALK","NORWICH","NORWICHTOWN","OAKDALE","OAKVILLE","OCCUM","OLD GREENWICH","OLD LYME","OLD MYSTIC","OLD SAYBROOK","ONECO","ORANGE","OXFORD","PAWCATUCK","PEQUABUCK","PERKINS CORNER","PINE MEADOW","PITNEY BOWES INC","PLAINFIELD","PLAINVILLE","PLANTSVILLE","PLAZA","PLEASANT VALLEY","PLEASANT VLY","PLYMOUTH","POINT O WOODS","POMFRET","POMFRET CENTER","POMFRET CTR","POMFRET LANDING","PONFRET CENTER","POQUETANUCK","POQUONOCK","POQUONOCK BRIDGE","PORTLAND","PRESTON","PROMOTION MARKETING SER INC","PROMOTION SYSTEMS INC","PROMOTIONAL DEV INC","PROSPECT","PUBLISHERS CLEARING HOUSE","PUTMAN","PUTNAM","PUTNAM HEIGHTS","PUTNM","QUAKER HILL","QUINEBAUG","REDDING","REDDING CENTER","REDDING CTR","REDDING RIDGE","RHODESVILLE","RIDGEFIELD","RIDGEWAY","RIVERSIDE","RIVERTON","ROCKFALL","ROCKVILLE","ROCKY HILL","ROGERS","ROWAYTON","ROXBURY","S GLASTONBURY","S WILLINGTON","S WOODSTOCK","SALEM","SALISBURY","SANDY HOOK","SAUGATUCK","SAWYER DISTRICT","SCANTIC","SCITICO","SCOTLAND","SETAN INDUSTRIES","SEYMOUR","SHARED ZIP FOR BRM","SHARON","SHARON VALLEY","SHAWONDASSEE","SHELTON","SHERMAN","SILVER LANE","SIMBURY","SIMSBURY","SOMERS","SOMERSVILLE","SOUTH BRITAIN","SOUTH CANAAN","SOUTH CANTERBURY","SOUTH CHAPLIN","SOUTH GLASTONBURY","SOUTH KENT","SOUTH KILLINGLY","SOUTH LYME","SOUTH NORWALK","SOUTH WILLINGTON","SOUTH WINDHAM","SOUTH WINDSOR","SOUTH WOODSTOCK","SOUTHBURY","SOUTHINGTON","SOUTHPORT","SPRAGUE","SPRINGDALE","STAFFORD","STAFFORD SP","STAFFORD SPGS","STAFFORD SPRINGS","STAFFORDVILLE","STAMFORD","STEPNEY","STERLING","STEVENSON","STONINGTON","STORRS","STORRS MANFLD","STORRS MANSFIELD","STRATFORD","SUB BASE NEW LONDON","SUBMARINE BASE","SUFFIELD","TACONIC","TAFTVILLE","TALCOTT VILLAGE","TALCOTTVILLE","TARIFFVILLE","TERRYVILLE","THE EXCHANGE AT TALCOTT VILL","THOMASTON","THOMPSON","THOMPSONVILLE","TOKENEKE","TOLLAND","TORRINGTON","TRAVELERS INS","TRUMBULL","TURNPIKE","TWIN LAKES","UNCASVILLE","UNION","UNION CITY","UNIONVILLE","UNIROYAL INC","UNITED STATES COAST GUARD","UNITY PLAZA","UNIVERSITY OF CT","UNIVERSITY OF CT HEALTH CTR","UPPER STEPNEY","US COAST GUARD ACAD","US POSTAL SERVICE","VERNON","VERNON ROCKVILLE","VERNON ROCKVL","VERSAILLES","VOLUNTOWN","W HARTFORD","W HAVEN","W HTFD","W SUFFIELD","W WILLINGTON","WALLINGFORD","WAPPING","WAREHOUSE POINT","WARREN","WARRENVILLE","WASHINGTON","WASHINGTON DEPOT","WASHINGTON DT","WASHINGTON GREEN","WATERBURY","WATERFORD","WATERTOWN","WAUREGAN","WEATHERSFIELD","WEATOGUE","WEBSTERS UNIFIED","WESLEYAN","WEST ASHFORD","WEST CORNWALL","WEST FARMS MALL","WEST GRANBY","WEST HARTFORD","WEST HARTFRD","WEST HARTLAND","WEST HAVEN","WEST MYSTIC","WEST REDDING","WEST SIMSBURY","WEST STAFFORD","WEST SUFFIELD","WEST WAUREGAN","WEST WOODS","WESTBROOK","WESTON","WESTPORT","WESTVILLE","WETH","WETHERSFIELD","WETHERSFLD","WHITNEYVILLE","WILLIMANTIC","WILLINGTON","WILSON","WILTON","WINCHESTER","WINCHESTER CENTER","WINCHESTR CTR","WINDHAM","WINDSOR","WINDSOR LOCKS","WINDSORVILLE","WINSTED","WOLCOTT","WOODBRIDGE","WOODBURY","WOODSTOCK","WOODSTOCK VALLEY","WOODSTOCK VLY","WTBY","YALESVILLE","YANTIC"],"MH":["EBEYE","EBEYE MARSHALL ISLANDS","MAJURO","MAJURO MARSHALL ISLANDS"]}
        getCities: async (state) => {
            // await waitTimeout(50);
            return state === "HI" ? (
                ["AHUALOA","AIEA","ANAHOLA","BANCORP","BANCORP HAWAII","BANK OF HAWAII","BOARD OF WATER SUPPLY","CAMP H M SMITH","CAMP SMITH","CAPTAIN COOK","EAST WEST CENTER","ELEELE","EWA BEACH","FIRST HAWAIIAN BANK","FORT SHAFTER","HAIKU","HAKALAU","HALEIWA","HANA","HANA MAUI","HANALEI","HANAMAULU","HANAPEPE","HAUULA","HAWAII NATIONAL PARK","HAWAII NATL PARK","HAWAIIAN ELECTRIC COMPANY","HAWAIIAN TELCOM","HAWI","HELEMANO MLTRY RES","HELEMANO MLTRY RESERVATION","HI NATL PARK","HICKAM AFB","HILO","HOLUALOA","HON","HONAUNAU","HONO","HONOKAA","HONOLULU","HONOMU","HOOLEHUA","JB PEARL HARBOR HICKAM","JBPHH","JOINT BASE PEARL HBR HICKAM","KAAAWA","KAHUKU","KAHULUI","KAILUA","KAILUA KONA","KALAELOA","KALAHEO","KALAUPAPA","KAMUELA","KANEOHE","KAPAA","KAPAAU","KAPOLEI","KAUMAKANI","KAUNAKAKAI","KAWAIHAE","KEAAU","KEALAKEKUA","KEALIA","KEAUHOU","KEKAHA","KIHEI","KILAUEA","KOLOA","KUALAPUU","KULA","KUNIA","KURTISTOWN","LAHAINA","LAIE","LANAI CITY","LAUPAHOEHOE","LAWAI","LIHUE","MAKAKILO","MAKAWAO","MAKAWELI","MAUNALOA","MCBH K BAY","MCBH KANEOHE BAY","MILILANI","MOUNTAIN VIEW","NAALEHU","NANAKULI","NINOLE","OCEAN VIEW","OOKALA","PAAUHAU","PAAUILO","PAHALA","PAHOA","PAIA","PAPAALOA","PAPAIKOU","PEARL CITY","PEARL HARBOR","PEARL HARBOR NAVAL BASE","PEPEEKEO","PRINCEVILLE","PUKALANI","PUKALANI MAUI","PUUNENE","SCHOFIELD","SCHOFIELD BARRACKS","TRIPLER AMC","TRIPLER ARMY MED CTR","TRIPLER ARMY MEDICAL CENTER","UNIVERSITY OF HAWAII","VOLCANO","WAHIAWA","WAIALUA","WAIANAE","WAIKOLOA","WAILEA","WAILUKU","WAIMANALO","WAIMEA","WAIPAHU","WAKE ISLAND","WHEELER AAF","WHEELER ARMY AIRFIELD"]
            ) : state === "CT" ? (
                ["A A R P PHARMACY","ABINGTON","ADVERTISING DISTR CO","AETNA INSURANCE","AETNA LIFE","ALLSTATE","AMSTON","ANDOVER","ANSONIA","ASHFORD","AVON","BAKERSVILLE","BALLOUVILLE","BALTIC","BANK OF AMERICA","BANTAM","BARKHAMSTED","BARRY SQUARE","BEACON FALLS","BELLE HAVEN","BERLIN","BETHANY","BETHEL","BETHLEHEM","BISHOPS COR","BISHOPS CORNER","BISSELL","BKLN","BLOOMFIELD","BLOOMINGDALES BY MAIL LTD","BLUE HILLS","BOLTON","BOROUGH","BOTSFORD","BOZRAH","BRADLEY INTERNATIONAL AIRPOR","BRANFORD","BRIDGEPORT","BRIDGEWATER","BRISTOL","BROAD BROOK","BROOKFIELD","BROOKFIELD CENTER","BROOKFLD CTR","BROOKLYN","BURLINGTON","C T MUTUAL INSURANCE CO","CANAAN","CANTERBURY","CANTON","CANTON CENTER","CENTER GROTON","CENTERBROOK","CENTERVILLE MOUNT CARMEL","CENTRAL","CENTRAL VILLAGE","CENTRAL VLG","CHAPLIN","CHERRY BROOK","CHESHIRE","CHESTER","CHESTERFIELD","CHESTNUT HILL","CLINTON","COBALT","COLBROOK","COLCHESTER","COLEBROOK","COLLINSVILLE","COLUMBIA","CONANTVILLE","CONN BANK & TRUST CO","CONNECTICUT STATE PRISON","CONTROLLED DISTRIBUTION","CORBINS CORNER","CORNWALL","CORNWALL BRG","CORNWALL BRIDGE","COS COB","COVENTRY","CROMWELL","CT DEPT OF MOTOR VEHICLES","CT GEN MED CLAIMS OFFICE","DANBURY","DANIELSON","DARIEN","DAYVILLE","DEEP RIVER","DERBY","DURHAM","E GLASTONBURY","E GLSTNBRY","E HARTFORD","E HAVEN","E HTFD","E KILLINGLY","E WINDSOR HL","E WOODSTOCK","EAST BERLIN","EAST BROOKLYN","EAST CANAAN","EAST END","EAST GLASTONBURY","EAST GRANBY","EAST HADDAM","EAST HAMPTON","EAST HARTFORD","EAST HARTLAND","EAST HAVEN","EAST HTFD","EAST KILLINGLY","EAST LYME","EAST NORWALK","EAST PUTNAM","EAST THOMPSON","EAST WILLINGTON","EAST WINDSOR","EAST WINDSOR HILL","EAST WOODSTOCK","EASTFORD","EASTON","ELLINGTON","ELLIOT","ELMWOOD","ENFIELD","ESSEX","EXETER","FABYAN","FAIR HAVEN","FAIRFIELD","FALLS VILLAGE","FARMINGTON","FENWICK","FITCHVILLE","FORBES VILLAGE","FORESTVILLE","FOSDICK CORP","FRANKLIN","FRANKLIN HILL","FT TRUMBULL","GALES FERRY","GAYLORDSVILLE","GECC","GENERAL ELECTRIC","GEORGETOWN","GILMAN","GLASGO","GLASTONBURY","GLENBROOK","GLENVILLE","GOSHEN","GRANBY","GREENS FARMS","GREENWICH","GRISWOLD","GROSVENOR DALE","GROSVENOR DL","GROTON","GROTON LONG POINT","GUILFORD","GURLEYVILLE","HADDAM","HADDAM NECK","HADLYME","HAMDEN","HAMPTON","HANOVER","HARTFORD","HARTFORD INSURANCE GROUP","HARTFORD NATL BANK","HARTFRD","HARWINTON","HAWLEYVILLE","HAZARDVILLE","HEBRON","HFD","HIGGANUM","HOPEVILLE","HOTCHKISS SCHOOL","HTD","HTFD","HUNTINGTON","INTERNATIONAL MASTERS PUB","IRS","IVORYTON","JC PENNEY CO","JEWETT CITY","JORDAN VILLAGE","JUPITER POINT","KENINGTON","KENSINGTON","KENT","KILLINGLY","KILLINGLY CENTER","KILLINGWORTH","LAKE GARDA","LAKESIDE","LAKEVILLE","LAUREL HILL","LEBANON","LEDYARD","LISBON","LITCHFIELD","LORDS POINT","LYME","MACYS BY MAIL","MADISON","MAIN OFFICE","MANCHESTER","MANSFIELD","MANSFIELD CENTER","MANSFIELD CTR","MANSFIELD DEPOT","MANSFIELD DPT","MANSFIELD HOLLOW","MARBLE DALE","MARION","MARLBORO","MARLBOROUGH","MASHANTUCKET","MASONS ISLAND","MBI INC","MCDOUGAL CORRECTIONAL FCLTY","MECHANICSVILLE","MELROSE","MERIDEN","MERROW","MIDDLE HADDAM","MIDDLEBURY","MIDDLEFIELD","MIDDLETOWN","MILFORD","MILLDALE","MILLSTONE","MONROE","MONTVILLE","MOODUS","MOOSUP","MORRIS","MOUNT CARMEL","MYSTIC","N BRANFORD","N FRANKLIN","N GROSVENORDL","N HAVEN","N STONINGTON","N WESTCHESTER","NAUGATUCK","NAVAL SUBMARINE BASE","NAVSUB BASE","NEPAUG","NEW BRIT","NEW BRITAIN","NEW CANAAN","NEW FAIRFIELD","NEW HARTFORD","NEW HAVEN","NEW LONDON","NEW MILFORD","NEW PRESTON","NEW PRESTON MARBLE DALE","NEW PRESTON MARBLEDALE","NEW PRESTON-MARBLE DALE","NEWINGTON","NEWTOWN","NIANTIC","NO CANAAN","NO HAVEN","NOANK","NORFOLK","NOROTON","NOROTON HEIGHTS","NORTH BRANFORD","NORTH CANAAN","NORTH CANTON","NORTH FRANKLIN","NORTH GRANBY","NORTH GROSVENDALE","NORTH GROSVENORDALE","NORTH HAVEN","NORTH LYME","NORTH STERLING","NORTH STONINGTON","NORTH THOMPSONVILLE","NORTH WESTCHESTER","NORTH WINDHAM","NORTHEAST AREA","NORTHFIELD","NORTHFORD","NORTHVILLE","NORWALK","NORWICH","NORWICHTOWN","OAKDALE","OAKVILLE","OCCUM","OLD GREENWICH","OLD LYME","OLD MYSTIC","OLD SAYBROOK","ONECO","ORANGE","OXFORD","PAWCATUCK","PEQUABUCK","PERKINS CORNER","PINE MEADOW","PITNEY BOWES INC","PLAINFIELD","PLAINVILLE","PLANTSVILLE","PLAZA","PLEASANT VALLEY","PLEASANT VLY","PLYMOUTH","POINT O WOODS","POMFRET","POMFRET CENTER","POMFRET CTR","POMFRET LANDING","PONFRET CENTER","POQUETANUCK","POQUONOCK","POQUONOCK BRIDGE","PORTLAND","PRESTON","PROMOTION MARKETING SER INC","PROMOTION SYSTEMS INC","PROMOTIONAL DEV INC","PROSPECT","PUBLISHERS CLEARING HOUSE","PUTMAN","PUTNAM","PUTNAM HEIGHTS","PUTNM","QUAKER HILL","QUINEBAUG","REDDING","REDDING CENTER","REDDING CTR","REDDING RIDGE","RHODESVILLE","RIDGEFIELD","RIDGEWAY","RIVERSIDE","RIVERTON","ROCKFALL","ROCKVILLE","ROCKY HILL","ROGERS","ROWAYTON","ROXBURY","S GLASTONBURY","S WILLINGTON","S WOODSTOCK","SALEM","SALISBURY","SANDY HOOK","SAUGATUCK","SAWYER DISTRICT","SCANTIC","SCITICO","SCOTLAND","SETAN INDUSTRIES","SEYMOUR","SHARED ZIP FOR BRM","SHARON","SHARON VALLEY","SHAWONDASSEE","SHELTON","SHERMAN","SILVER LANE","SIMBURY","SIMSBURY","SOMERS","SOMERSVILLE","SOUTH BRITAIN","SOUTH CANAAN","SOUTH CANTERBURY","SOUTH CHAPLIN","SOUTH GLASTONBURY","SOUTH KENT","SOUTH KILLINGLY","SOUTH LYME","SOUTH NORWALK","SOUTH WILLINGTON","SOUTH WINDHAM","SOUTH WINDSOR","SOUTH WOODSTOCK","SOUTHBURY","SOUTHINGTON","SOUTHPORT","SPRAGUE","SPRINGDALE","STAFFORD","STAFFORD SP","STAFFORD SPGS","STAFFORD SPRINGS","STAFFORDVILLE","STAMFORD","STEPNEY","STERLING","STEVENSON","STONINGTON","STORRS","STORRS MANFLD","STORRS MANSFIELD","STRATFORD","SUB BASE NEW LONDON","SUBMARINE BASE","SUFFIELD","TACONIC","TAFTVILLE","TALCOTT VILLAGE","TALCOTTVILLE","TARIFFVILLE","TERRYVILLE","THE EXCHANGE AT TALCOTT VILL","THOMASTON","THOMPSON","THOMPSONVILLE","TOKENEKE","TOLLAND","TORRINGTON","TRAVELERS INS","TRUMBULL","TURNPIKE","TWIN LAKES","UNCASVILLE","UNION","UNION CITY","UNIONVILLE","UNIROYAL INC","UNITED STATES COAST GUARD","UNITY PLAZA","UNIVERSITY OF CT","UNIVERSITY OF CT HEALTH CTR","UPPER STEPNEY","US COAST GUARD ACAD","US POSTAL SERVICE","VERNON","VERNON ROCKVILLE","VERNON ROCKVL","VERSAILLES","VOLUNTOWN","W HARTFORD","W HAVEN","W HTFD","W SUFFIELD","W WILLINGTON","WALLINGFORD","WAPPING","WAREHOUSE POINT","WARREN","WARRENVILLE","WASHINGTON","WASHINGTON DEPOT","WASHINGTON DT","WASHINGTON GREEN","WATERBURY","WATERFORD","WATERTOWN","WAUREGAN","WEATHERSFIELD","WEATOGUE","WEBSTERS UNIFIED","WESLEYAN","WEST ASHFORD","WEST CORNWALL","WEST FARMS MALL","WEST GRANBY","WEST HARTFORD","WEST HARTFRD","WEST HARTLAND","WEST HAVEN","WEST MYSTIC","WEST REDDING","WEST SIMSBURY","WEST STAFFORD","WEST SUFFIELD","WEST WAUREGAN","WEST WOODS","WESTBROOK","WESTON","WESTPORT","WESTVILLE","WETH","WETHERSFIELD","WETHERSFLD","WHITNEYVILLE","WILLIMANTIC","WILLINGTON","WILSON","WILTON","WINCHESTER","WINCHESTER CENTER","WINCHESTR CTR","WINDHAM","WINDSOR","WINDSOR LOCKS","WINDSORVILLE","WINSTED","WOLCOTT","WOODBRIDGE","WOODBURY","WOODSTOCK","WOODSTOCK VALLEY","WOODSTOCK VLY","WTBY","YALESVILLE","YANTIC"]
            ) : (
                ["EBEYE","EBEYE MARSHALL ISLANDS","MAJURO","MAJURO MARSHALL ISLANDS"]
            );
        },

        // URL : /next-api/location/get_eddm_zip_codes/
        // Request: {"cities":[{"state":"AL","city":"GADSDEN"},{"state":"AL","city":"FULTON"},{"state":"IN","city":"TEFFT"}]}
        // Response: [35901,35902,35903,35904,35905,35906,35907,36446,46380],
        getZipCodes: async ({state, city}) => {
            // await waitTimeout(50);
            return [35901,35902,35903,35904,35905,35906,35907,36446,46380];
        },
    },

    bulkMailPermit: {
        // getIndica: () => null,
        getIndica: () => ({
            "idPrimary": 22571,
            "title": "",
            "line1": "SAMPLE MAIL",
            "line2": "US POSTAGE",
            // "line3": "PAID",
            // "line4": "FORT WORTH, TX",
            // "line5": "PERMIT NO. 1234",

            "idCompany": "283JACKCON",
            "idBranch": "57112DEMOB",
            "idAgent": "473883JANE",
            "companyUse": false,
            "branchUse": false,
            "agentUse": true,
            "uid": "fc9706dbdb8fdf13dd4f01a9626589c7"
        }),

        saveIndicia: ({indicia}) => {
            console.log("saveIndicia", indicia);
            console.log(arrMapToO(createArray(5), (i) => indicia["line"+ (i+1)] ?? "", (i) => "line"+(i+1)));
        },
    },

    imb: {
        getMailerId: async () => {
            // GET /next-api/mailer/getMailerId

            // return null;

            return {
                idPrimary: 123,
                idMailer: 2340912,
            };
        },

        saveMailerId: async ({idMailer, idPrimary}) => {

            // {"result":"failure","error":{"target":"saveMailerId","msg":"The Mailer ID you provided is invalid. Values must be numeric and between 6 to 9 characters in length."}}

            // {"error":{"fatal":"1","errors":[{"target":"validateIdEntity","msg":"agent level not have access another mailer ids"}]}}

            await waitTimeout(200);

            throw "The Mailer ID you provided is invalid. Values must be numeric and between 6 to 9 characters in length.";
            return {
                result: "success",
            };
        },
    },


    userProfile: {
        getUserProfile: async (userId?: string) => {
            // await waitTimeout(200);
            return ({"id": 1874703, "userActive": 1, "username": "c0e3e17fd2", "userLevel": "Agent", "loginLevel": 4});
        },
        // updateUserProfile: async ({userId=undefined,...updateFields}) => (
        //     await authFetcher.postJson(`/next-api/userProfile/update`, userId ? {userId, ...updateFields} : updateFields)
        // ),
    },

    sampleAddress: {
        getSampleAddress: async () => {
            // await waitTimeout(500);
            // GET /next-api/sample_address/get_sample_address
            return {
                "idPrimary": 302122,
                "idAgent": "047d990a52",
                "idBranch": "",
                "idCompany": "",

                "name": "JANE  AGENT",
                "name2": "",
                "address": "4901 N BEACH ST",
                "address2": "",
                "city": "FORT WORTH",
                "state": "TX",
                "zip": "76137",

                "countryCode": "US",

                "mailSampleCard": 1,
                "result": 0,

                "cassStatus": "1",
                // "failed": "1",
                "failed": "0",
                "errorCode": "ABC",
            };
        },

        saveSampleAddress: async (data) => {},
        cassSampleAddress: async (id) => ({description: "AADAWEDWED"}),
    },


    social: MockNextSocialApis(),

    // gallery: {
    //     headshots: {
    //         getImages: async () => [
    //             {
    //                 "dateCreated":"2022-10-11T19:50:50-05:00",
    //                 "dateModified":"2022-10-11T19:50:50-05:00",
    //                 "name":"aa",
    //                 "fileType":"png",
    //                 "fileSize":15297,
    //                 "thumbnailUrl":"https:\/\/assets.awsdev.xpressdocs.com\/dserv\/p\/3\/29643534.png",
    //                 "quality":"Low",
    //                 "defaultSlot":0,
    //                 "width":692,"height":148,"printUrl":"https:\/\/assets.awsdev.xpressdocs.com\/pictures\/headshot\/2022\/10\/11\/3\/29643534o.png","id":29643534
    //             },
    //         ],
    //     },
    // },

    adBudgets: {
        getUserAdBudget: async () => ({
            "idBranch": "32517238",
            "idAgent": "f3866ab8",
            "name": "Lorelai Gilmore",
            "amount": 100,
            "status": false
        }),
        getAdBudgetDefaults: async () => ({
            "933SPOKANE": {
                amount: 123,
            },
            "1a71908a": {
                amount: 123,
            },
            "f6ee898223": {
                amount: 123,
            },
            DEFAULT: {
                amount: 123,
            },
        }),
        setAdBudgetDefaults: async () => {},
    },

    userCreated: {
        getFolders: async () => {
            return [
                // {
                //     id: 1,
                //     name: "Main Folder",
                //     numImages: 10,
                //     subFolders: [
                //         {
                //             id: 1,
                //             name: "Sub Folder 1",
                //             numImages: 5,
                //         },
                //         {
                //             id: 2,
                //             name: "Sub Folder 2",
                //             numImages: 3,
                //         },
                //         {
                //             id: 3,
                //             name: "Sub Folder 3",
                //             numImages: 2,
                //         },
                //     ],
                // },
            ];
        },
        getProducts: async () => ({}),
    },

    billing: {
        getBillingAccounts: async () => {
            // await waitTimeout(312);
            return [
                {
                    idAccount: "123",
                    accountName: "Company Billing 1",
                },
                {
                    idAccount: "124",
                    accountName: "Company Billing 2",
                },
            ];
        },
    },

    informedDelivery: mockNextInformedDeliveryApis,

    networking: mockNextNetworkingApis,
});

